export default "__VITE_ASSET__1a3f2a55__"